module.exports = __webpack_public_path__ + "static/media/mediPangPang_textType_v1.0_72_32.c94f5bea.svg";